import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-surface-section font-inter flex h-screen items-center justify-center" }
const _hoisted_2 = { class: "max-w-screen-xl px-4 py-8 lg:px-6 lg:py-16" }
const _hoisted_3 = { class: "mx-auto max-w-screen-sm space-y-6 text-center" }
const _hoisted_4 = { class: "text-bluegray-900 mb-4 text-3xl font-bold tracking-tight md:text-4xl" }


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorView',
  setup(__props) {

const MESSAGES: Record<number, string> = {
  403: 'Nie masz dostępu do tej strony',
};

return (_ctx: any,_cache: any) => {
  const _component_PrimeButton = _resolveComponent("PrimeButton")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(MESSAGES[Number(_ctx.$route.params.status)] ||
            'Coś poszło nie tak podczas pobierania danych. Spróbuj ponownie później.'), 1),
        _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-global-textColor mb-4 text-lg font-light" }, " Przepraszamy za niedogodności. Proszę przejść do strony głównej. ", -1)),
        _createVNode(_component_RouterLink, { to: "/" }, {
          default: _withCtx(() => [
            _createVNode(_component_PrimeButton, { rounded: "" }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode(" Przejdź do strony głównej ")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})